import sessionManager from "./sessionManager";
import { requestAuth } from "./authRequest";
import { refreshSession } from "./tokenRefresh";

let pending = null;
export function signOut({ all = false, redirect = true } = {}) {
  if (pending) return pending;
  const session = sessionManager.getSessionSnapshot();
  pending = (async () => {
    let confirmed = !session.access;
    try {
      if (session.access) {
        const path = all ? "/auth/security/sign-out-all/" : "/logout";
        try { await requestAuth(path, {}, { access: session.access, timeoutMs: 8000 }); } catch (error) {
          if (error.status !== 401 || !session.refresh) throw error;
          const current = sessionManager.getSessionSnapshot();
          if (current.sessionEpoch !== session.sessionEpoch || current.userId !== session.userId) throw error;
          const tokens = await refreshSession();
          await requestAuth(path, {}, { access: tokens.access, timeoutMs: 8000 });
        }
        confirmed = true;
      }
    } catch (error) {
      // Keep a working session when a global sign-out could not be confirmed.
      if (all) throw error;
    }
    const current = sessionManager.getSessionSnapshot();
    if (current.sessionEpoch === session.sessionEpoch && current.userId === session.userId) {
      await sessionManager.reset({ reason: "logout", redirect, target: confirmed ? "/login" : "/login?signout=local" });
    }
    return confirmed;
  })().finally(() => { pending = null; });
  return pending;
}
